'use client';
import { LoadingSpinner } from '@/shared/components';

export default function Loading() {
  return (
    <div className="absolute inset-0 flex flex-col justify-center items-center bg-opacity-30 bg-gray-200 w-full">
      <LoadingSpinner classToAdd="w-8 h-8" />
      <p className="mt-2">Loading</p>
    </div>
  );
}
